<template>
  <div class="p-practice-content">
    <div class="topic-resource">
      <div style="min-height: 500px">
        <!-- <div class="topic-resource__all">共{{pagination.total}}道题目</div> -->
        <div class="topic-resource__header">
          <basket-header>
            {{ overviewData.evaluate_name }}
          </basket-header>
        </div>
        <!-- 题目列表 -->
        <div v-for="(item, index) in questionList" :key="index">
          <div v-if="item.question_title_uuid === '' " class="content">
          <!-- 知识点 -->
          <span class="content__title"
            v-for="(Kitem, kindex) in item.knowledge"
            :key="kindex">{{ Kitem.tag_name }}</span>
            <!-- 题干 -->
          <div class="content__count">
            <p>{{ index + 1 }}、</p>
            <p v-if="type" v-katexHtml="item.content.content" />
            <p v-katexUbb="htmlDeCode(item.content.content)" v-else />
          </div>
          <!-- 英语听力 -->
          <div
            class="content__audio"
            v-if="
              item.content &&
              item.content.hearing &&
              item.content.hearing[0] &&
              item.content.hearing[0].source
            "
            @click="controlAudio(item.question_id)"
          >
            <p
              class="audio-pause"
              :class="
                isAudioPlaying && currentQuestionUuid === item.question_uuid
                  ? 'voice-playing'
                  : ''
              "
            ></p>
            <audio
              ref="audio"
              :id="`audio${item.question_id}`"
              :src="item.content.hearing[0].source"
              @pause="onPause"
              @play="onPlay"
            />
          </div>
          <!-- 判断题 -->
            <div
            v-if="item.question_type === 3 && item.show_type  === '103'"
            class="content__option"
          >
            <div
              v-for="(oitem, oindex) in Number(overviewData.subject_id) === 1
                ? enText
                : cnText"
              :key="oindex"
            >
              <p>{{ oitem }}</p>
            </div>
          </div>
          <!-- 所有选项 -->
          <div class="question-analysis__option">
            <div v-for="(oitem, oindex) in item.options" :key="oindex">
              <p>{{ oitem.key }}：</p>
              <p v-katexHtml="oitem.content"></p>
            </div>
          </div>
          <!-- 选词填空 -->
          <div
            v-if="
              item &&
              item.question_type === 6
            "
            class="content__option"
          >
            <div
              v-for="(oitem, oindex) in item.choice_words"
              :key="oindex"
            >
              <p v-katexUbb="htmlDeCode(oitem.content)"></p>
            </div>
          </div>
          <!-- 非题冒题 -->
          <div class="content__footer">
            <div>
              <p>
                <span>题型: </span>
                <span>{{ questionName(
                      item.question_type,
                      item.show_type,
                      item.question_title_uuid,) || item.question_type_name }}</span>
              </p>
              <p>
                <span>难度: </span>
                <span>{{ item.difficulty }}</span>
              </p>
              <p>
                <span>答题次数: </span>
                <span>{{ item.total }}</span>
              </p>
            </div>
            <div class="footer__right">
              <p
                class="tickling pointer"
                @click="submitAnalysis(item.question_uuid)"
                v-if="!isPad"
              >
                反馈
              </p>
              <p class="analysis pointer">
                <span
                  v-if="item.active"
                  style="margin-left: 6px"
                  @click="closeAnalysis(item)"
                  >收起解析</span
                >
                <span
                  v-else
                  style="margin-left: 6px"
                  @click="openAnalysis(item)"
                  >查看解析</span
                >
              </p>
            </div>
          </div>
        </div>
        <div v-else>
          <!-- 题冒题 -->
          <ul>
            <li class="content">
              <div class="content__count">
                <div v-if="item.title_question
                && item.title_question.content">
                <el-popover
                  placement="right"
                  popper-class="popover"
                  title=""
                  width="600"
                  trigger="click"
                  >
                  <p v-if="type" v-katexHtml="item.title_question.content.content"></p>
                  <p
                    v-katexUbb="htmlDeCode(item.title_question.content.content)"
                    v-else />
                    <!-- 英语听力 -->
                  <div
                    class="content__audio"
                    v-if="
                      item.title_question &&
                      item.title_question.content &&
                      item.title_question.content.hearing&&
                      item.title_question.content.hearing[0] &&
                      item.title_question.content.hearing[0].source
                    "
                    @click="controlAudio(item.question_id)"
                  >
                    <p
                      class="audio-pause"
                      :class="
                        isAudioPlaying && currentQuestionUuid === item.question_uuid
                          ? 'voice-playing'
                          : ''
                      "
                    ></p>
                    <audio
                      ref="audio"
                      :id="`audio${item.question_id}`"
                      :src="item.title_question.content.hearing[0].source"
                      @pause="onPause"
                      @play="onPlay"
                    />
                  </div>
                  <p slot="reference" class="pointer title-uuid">查看原文</p>
                </el-popover>
                  <p style="display: inline-block;">{{ index + 1 }}、</p>
                  <p style="display: inline-block;"
                  v-katexUbb="htmlDeCode(item.content.content)" />
                </div>
              </div>
              <!-- 选词填空 -->
              <div
                v-if="
                  item &&
                  item.question_type === 6 &&
                  item.show_type === '112'
                "
                class="content__option"
              >
                <div v-for="(oitem, oindex) in item.choice_words" :key="oindex">
                  <p v-katexUbb="htmlDeCode(oitem.content)"></p>
                </div>
              </div>
              <!-- 判断题 -->
              <div
                v-if="
                  item &&
                  item.question_type === 3 &&
                  item.show_type === '103'
                "
                class="content__option"
              >
                <div v-for="(oitem, oindex) in Number(overviewData.subject_id) === 1
                ? enText
                : cnText" :key="oindex">
                  <p>{{ oitem }}</p>
                </div>
              </div>
              <div class="content__option" v-else>
                <div v-for="(oitem, oindex) in item.options"
                :key="oindex">
                  <p>{{ oitem.key }}：</p>
                  <p v-katexHtml="oitem.content"></p>
                </div>
              </div>
              <div class="content__footer">
            <div>
              <p>
                <span>题型: </span>
                <span>{{ questionName(
                      item.question_type,
                      item.show_type,
                      item.question_title_uuid,) }}</span>
              </p>
              <p>
                <span>难度: </span>
                <span>{{ item.difficulty }}</span>
              </p>
            </div>
            <div class="footer__right">
              <p
                class="tickling pointer"
                @click="submitAnalysis(item.question_uuid)"
                v-if="!isPad"
              >
                反馈
              </p>
              <p class="analysis pointer">
                <span
                  v-if="item.active"
                  style="margin-left: 6px"
                  @click="closeAnalysis(item)"
                  >收起解析</span
                >
                <span
                  v-else
                  style="margin-left: 6px"
                  @click="openAnalysis(item)"
                  >查看解析</span
                >
              </p>
            </div>
          </div>
            </li>
          </ul>
        </div>
        <!-- 展开解析 -->
        <ul class="question-analysis" v-if="item.active">
          <li class="question-analysis__answer">
            <span style="min-width: 110px">正确答案:</span>
            <!-- 理科正确答案 -->
            <div v-if="type">
              <div v-if="item.question_type !== 3">
                <span
                  v-for="(aitem, aindex) in item.answer"
                  :key="aindex"
                  class="right-answer"
                  v-katexHtml="aitem"
                ></span>
              </div>
              <div v-else class="completion">
                <div v-for="(aitem, aindex) in item.answer" :key="aindex">
                  <div
                    v-for="(childItem, childIndex) in aitem"
                    :key="childIndex"
                  >
                    <span
                      v-katexHtml="childItem.content"
                      class="right-answer"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 文科 -->
            <div v-else>
              <p v-if="item.question_type !== 3 && item.question_type !== 6 ">
              <span
                v-for="(aitem, aindex) in item.answer"
                :key="aindex"
                class="right-answer"
                v-katexUbb="htmlDeCode(aitem)"
              ></span>
              </p>
              <div v-else class="completion">
                <div v-if="item.question_type === 3 && (item.show_type === '103'
                || item.show_type)">
                  <div
                    v-for="(aitem, aindex) in item.answer"
                    :key="aindex"
                    class="right-answer">
                      <span v-if="Number(overviewData.subject_id) === 3">
                        {{ aitem.content === "T" ? "正确" : "错误" }}
                      </span>
                      <span v-else>
                        {{ aitem.content === "T" ? "True" : "False" }}
                      </span>
                  </div>
                </div>
                <div v-else v-for="(aitem, aindex) in item.answer" :key="aindex">
                  <div v-for="(childItem, childIndex) in aitem" :key="childIndex">
                    <span
                      v-katexUbb="htmlDeCode(childItem.content)"
                      class="right-answer"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="question-analysis__text"
            v-if="item.analyze &&
              item.analyze[0]  &&
              item.analyze[0].content &&
              item.analyze[0].content[0] &&
              item.analyze[0].content[0].content !== '' ||
              (item.analyze &&
              item.analyze[0] &&
              item.analyze[0].title !== '')">
            <span style="min-width: 110px">文字解析:</span>
            <!-- 理科 -->
            <div v-if="type">
              <div
                v-for="(zitem, zindex) in item.analyze"
                :key="zindex"
                class="text-content"
              >
                <span v-katexHtml="zitem.title"></span>
                <span v-katexHtml="zitem.content[0] &&zitem.content[0].content"></span>
              </div>
            </div>
            <div v-else>
              <div
                v-for="(zitem, zindex) in item.analyze"
                :key="zindex"
                class="text-content"
              >
                <span v-katexUbb="htmlDeCode(zitem.title)"></span>
                <span v-katexUbb="htmlDeCode(zitem.content[0] && zitem.content[0].content)"></span>
              </div>
            </div>
          </li>
          <li
            class="question-analysis__videos"
            v-if="item.question_source && item.question_source.length > 0"
          >
            <p>视频解析:</p>
            <p
              class="video-content"
              @click.stop="videoOpen(item.question_source[0].source_url)"
            >
              <span>播放</span>
            </p>
          </li>
        </ul>
        </div>
        <div v-if="questionList.length < 1" class="empty">
          <img src="../../images/emptyType.png" alt="" />
        </div>
      </div>
      <!-- 反馈弹框 -->
      <analysis-dialog
        :centerDialogVisible.sync="centerDialogVisible"
        :questionUUid="questionUUid"
      />
      <!-- 视频弹框 -->
      <video-dialog :dialogVisible.sync="dialogVisible" :videoUrl="videoUrl" />
    </div>

    <div class="topic-option">
      <div class="mt-16">
        <el-button type="primary" class="option-btn" @click="againPublish"
          >再次布置</el-button
        >
      </div>
      <!-- <div class="mt-16">
         <el-button icon="el-icon-search" class="option-btn" @click="downPractice">下载练习</el-button>
      </div> -->
      <div class="mt-16">
        <el-button
          icon="el-icon-search"
          class="option-btn"
          @click="printPractice"
          >打印练习</el-button
        >
      </div>
      <div class="point-selected mt-16">
        <div class="selected-sign" />
        <div class="selected-num">知识点数: </div>
        <div class="ml-20">{{ codeNum }}个</div>
      </div>
      <div class="topic-selected mt-16">
        <div class="selected-header">
          <div class="selected-sign" />
          <div class="selected-num">题目数：</div>
          <div class="ml-20">{{ total }}道</div>
        </div>
        <div class="selected-content">
          <div class="content-item">
            <div class="content-name">单选题</div>
            <div class="content-num">{{ typeCheck }}道</div>
          </div>
          <div class="content-item">
            <div class="content-name">多选题</div>
            <div class="content-num">{{ typeMoreCheck }}道</div>
          </div>
          <div class="content-item">
            <div class="content-name">填空题</div>
            <div class="content-num">{{ typeWrite }}道</div>
          </div>
          <div class="content-item">
            <div class="content-name">判断题</div>
            <div class="content-num">{{ typeJude }}道</div>
          </div>
          <div class="content-item">
            <div class="content-name">选词填空</div>
            <div class="content-num">{{ typeChangeWrite }}道</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { htmlDecodeByRegExp } from '@/utils';
import _ from 'lodash';
import BasketHeader from '@/components/basket-header.vue';
import analysisDialog from '../../lesson-prepare/components/analysis-dialog.vue';
import videoDialog from '../../lesson-prepare/components/video-dialog.vue';
import { getQuestionList, getQuestionDetailById } from '@/api/pt';

export default {
  name: 'PracticeContent',
  components: {
    analysisDialog,
    videoDialog,
    BasketHeader,
  },
  props: {
    overviewData: {
      type: Object,
      default: () => { },
    },
    type: {},
  },
  data() {
    return {
      isAudioPlaying: false,
      scienceArr: [2, 4, 5],
      cnText: ['正确', '错误'],
      enText: ['True', 'False'],
      questionList: [],
      isPad: this.$route.query.spad,
      codeNum: 0,
      total: 0,
      typeCheck: 0,
      typeMoreCheck: 0,
      typeWrite: 0,
      typeJude: 0,
      typeChangeWrite: 0,
      centerDialogVisible: false,
      analysisType: false,
      analysisNumber: 0,
      oneType: false,
      currentQuestionid: '',
      pagination: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      dialogVisible: false,
      videoUrl: '',
      questionUUid: '',
    };
  },
  computed: {
    videoType() {
      return (val) => {
        if (val) {
          val.some((item, index) => val[index].video_data.length > 0);
        }
      };
    },
  },
  watch: {
    overviewData() {
      this.getData();
    },
  },
  mounted() {
    // document.getElementsByClassName('el-pagination__jump')[0].childNodes[0].nodeValue = '跳至';
    // this.getData();
  },
  methods: {
    getData() {
      getQuestionList({
        // evaluate_id: 80451,
        // school_id: 2394,
        evaluate_id: this.overviewData.evaluate_id,
        school_id: this.$route.query.schoolId || 20043,
      }).then(({ data }) => {
        this.questionList = data.list;
        this.pagination.total = data.total;
        this.codeNum = data.code_num;
        this.total = data.total;
        let typeCheck = 0;
        let typeMoreCheck = 0;
        let typeWrite = 0;
        let typeJude = 0;
        let typeChangeWrite = 0;
        this.questionList.forEach((item) => {
          if (item.question_type === 1 && item.show_type === '100') {
            typeCheck += 1;
          } if (item.question_type === 2 && item.show_type === '101') {
            typeMoreCheck += 1;
          } if (item.question_type === 3 && item.show_type === '102') {
            typeWrite += 1;
          } if (item.question_type === 3 && item.show_type === '103') {
            typeJude += 1;
          } if (item.question_type === 6 && item.show_type === '112') {
            typeChangeWrite += 1;
          }
          this.$set(item, 'analyze', [{ content: [] }]);
          this.$set(item, 'question_source', []);
        });
        this.typeCheck = typeCheck;
        this.typeWrite = typeWrite;
        this.typeMoreCheck = typeMoreCheck;
        this.typeJude = typeJude;
        this.typeChangeWrite = typeChangeWrite;
      });
    },
    getQuestionDetail(item) {
      getQuestionDetailById({
        question_id: item.question_uuid,
      }).then((res) => {
        if (res.code === 200) {
          // const answerArr = [];
          const analyzes = _.get(res.data, 'analyze');
          const questionSource = _.get(res.data, 'question_source');
          const questionList = _.get(res.data, 'question_list');
          this.$set(item, 'analyze', analyzes);
          this.$set(item, 'question_source', questionSource);
          this.$set(item, 'question_list', questionList);
        }
      });
    },
    // 发布
    async againPublish() {
      if (!this.questionList.length) return;
      await this.setStoreData();
      await this.putInBasket();
      this.$router.push({
        path: '/pt/publish-mt',
        query: {
          from: 'mt',
          type: 'again',
        },
      });
    },
    // 下载
    downPractice() {
    },
    getPerson(obj) {
      console.log(obj, 'obj');
      const person = Object.values(obj).join('、');
      return person;
    },
    questionName(question, show) {
      let name = '';
      if (question === 1 && show === '100') {
        name = '单选题';
      } else if (question === 2 && show === '101') {
        name = '多选题';
      } else if (question === 3 && show === '102') {
        name = '填空题';
      } else if (question === 3 && show === '103') {
        name = '判断题';
      } else if (question === 6 && show === '112') {
        name = '选词填空';
      }
      return name;
    },
    // 打印
    async printPractice() {
      if (!this.questionList.length) return;
      await this.putInBasket();
      this.$router.push({
        path: '/pt/export-question',
        query: {
          subjectId: this.overviewData.subject_id,
        },
      });
    },
    putInBasket() {
      return new Promise((resolve) => {
        this.$store.commit('CLEAR_QUESTIONS_BASKET', []);
        this.questionList.forEach((item) => {
          const item1 = item;
          item1.knowledge = item.knowledge_codes;
          this.$store.commit('PUTIN_QUESTIONS_BASKET', item);
        });
        resolve();
      });
    },
    setStoreData() {
      return new Promise((resolve) => {
        const categoryObj = {
          subjectId: this.overviewData.subject_id,
          subjectName: this.overviewData.subject_name,
          gradeId: '',
          gradeName: '',
          textbookId: this.overviewData.textbook_id,
          textbookName: this.overviewData.textbook_name,
          termId: '',
          termName: '',
        };
        this.$store.commit('SET_CATEGORY_OBJ', categoryObj);
        this.$store.commit('CHANGE_COURSE_INFORMATION', {
          courseId: this.overviewData.course_id,
          courseName: this.overviewData.course_name,
        });
        resolve();
      });
    },
    submitAnalysis(uuid) { // 反馈
      this.questionUUid = uuid;
      this.centerDialogVisible = true;
    },
    videoOpen(val) {
      this.dialogVisible = true;
      this.videoUrl = val;
    },
    amendPagination(page, size) {
      this.pagination.currentPage = page;
      this.pagination.pageSize = size;
    },
    getQuestion(val) { // 渲染列表
      this.pagination.total = val.total;
      this.questionList = val.data;
      this.questionList.forEach((item) => {
        this.$set(item, 'active', true);
      });
    },
    sizeChange(v) { // 每页条数
      this.pagination.pageSize = v;
    },
    currentChange(v) { // 当前页
      this.pagination.currentPage = v;
    },
    openAnalysis(item) {
      this.$set(item, 'active', true);
      this.currentQuestionid = item.question_uuid;
      this.getQuestionDetail(item);
      // return { ...data, active: false };
    },
    closeAnalysis(item) {
      this.$set(item, 'active', false);
      // return { ...data, active: true };
    },
    // 转换html字符串
    htmlDeCode(str) {
      return htmlDecodeByRegExp(str, 1);
    },
    // 音频播放状态
    onPlay() {
      console.log('音频开始播放了');
      this.isAudioPlaying = true;
    },
    // 音频暂停状态
    onPause() {
      console.log('音频暂停了');
      this.isAudioPlaying = false;
    },
    controlAudio(index) {
      const id = `audio${index}`;
      if (this.currentQuestionUuid === index && this.isAudioPlaying) {
        this.isAudioPlaying = false;
        this.$refs.audio.forEach((item) => {
          if (item.id === id) {
            item.pause();
          }
        });
      } else if (this.currentQuestionUuid === index && !this.isAudioPlaying) {
        this.isAudioPlaying = true;
        this.$refs.audio.forEach((item) => {
          if (item.id === id) {
            item.play();
          }
        });
      } else if (this.currentQuestionUuid !== index && !this.isAudioPlaying) {
        this.currentQuestionUuid = index;
        this.isAudioPlaying = true;
        this.$refs.audio.forEach((item) => {
          if (item.id === id) {
            item.play();
          } else {
            item.pause();
          }
        });
      } else if (this.currentQuestionUuid !== index && this.isAudioPlaying) {
        this.currentQuestionUuid = index;
        this.$refs.audio.forEach((item) => {
          if (item.id === id) {
            item.play();
          } else {
            item.pause();
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.p-practice-content {
  display: flex;
  background: #f2f2f2;
  .topic-resource {
    width: 75%;
    font-size: 14px;
    box-sizing: border-box;
    background: #fff;
    box-shadow: 0px 2px 16px 0px rgba(220, 225, 236, 0.5);
    & /deep/ .el-input--mini {
      margin-left: 80px;
    }
    &__img {
      width: 12px;
      height: 12px;
    }
    &__all {
      position: absolute;
      right: 0;
      top: 224px;
    }
    &__header {
      display: flex;
      justify-content: center;
    }
    &__card {
      position: relative;
      min-height: 100px;
      margin-left: 28px;
      margin-top: 28px;
      background: #ffffff;
      padding: 22px 0;
      background-size: 100% 48px;
      border: 4px solid rgba(118, 194, 255, 0.14);
      border-radius: 12px;
      &__title {
        display: inline-block;
        min-width: 89px;
        padding: 5px;
        margin-right: 5px;
        margin-left: 25px;
        line-height: 24px;
        text-align: center;
        background: #f0f2f5;
        border-radius: 3px;
        border: 1px solid #d7dfec;
      }
      &__count {
        display: flex;
        margin-top: 16px;
        width: 584px;
        font-size: 15px;
        padding: 0 25px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #111f2c;
        line-height: 21px;
        div {
          margin-right: 6px;
        }
      }
      &__option {
        div {
          display: inline-block;
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          margin: 10px 20px 0;
          p {
            display: inline-block;
            margin-right: 5px;
            word-break: break-all;
          }
        }
      }
      &__footer {
        padding: 0 25px;
        line-height: 40px;
        position: relative;
        bottom: -23px;
        background-color: #f5f9ff;
        border-radius: 0 0 12px 12px;
      }
      &__type {
        display: inline-block;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #5a5e66;
        line-height: 20px;
        margin-right: 48px;
      }
      &__feedback {
        float: right;
        margin-right: 44px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #1989fa;
      }
      &__analysis {
        float: right;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #1989fa;
        word-break: break-all;
      }
    }
    &__paging {
      position: relative;
      left: 80px;
      top: -28px;
    }
    &__analysis {
      margin-left: 48px;
      margin-right: 20px;
      background: #ffffff;
      border-radius: 0px 0px 12px 12px;
      border: 4px solid rgba(118, 194, 255, 0.14);
      border-top: none;
      padding: 10px 22px;
      padding-bottom: 1px;
      &__option {
        div {
          display: inline-block;
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          margin: 0 20px;
          p {
            display: inline-block;
            margin-right: 5px;
            word-break: break-all;
          }
        }
      }
      &__answer {
        font-size: 15px;
        min-width: 120px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 53px;
        display: flex;
      }
      &__content {
        position: relative;
        left: 40px;
        margin-right: 5px;
        color: #7dcb56;
        display: flex;
      }
      &__boundary {
        border: 1px dotted #dce1eb;
      }
      &__text {
        display: flex;
        font-size: 15px;
        margin-top: 20px;
        margin-bottom: 20px;
        justify-content: flex-start;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
      }
      &__video {
        display: flex;
        font-size: 15px;
        margin-top: 20px;
        margin-bottom: 20px;
        justify-content: flex-start;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        span {
          vertical-align: baseline;
          margin-right: 5px;
        }
        &__type {
          display: inline-block;
          width: 84px;
          height: 28px;
          background: no-repeat url("../../images/class_video.png") 1px center
            #ffa82d;
          border-radius: 14px;
          text-align: center;
          color: #fff;
          line-height: 28px;
          p {
            text-indent: 1em;
            font-size: 12px;
            margin-left: 10px;
          }
        }
      }
    }
    & /deep/ .el-pagination {
      margin-top: 20px;
      display: flex;
      margin-left: 30px;
      width: calc(100% - 64px);
      bottom: 30px;
      left: 32px;
      & .btn-prev {
        margin-left: auto;
      }
      & .el-select {
        left: -55px;
      }
    }
    &__left {
      width: 27px;
      position: absolute;
      left: -1px;
      bottom: 0px;
      border-radius: 0 0 0 12px;
    }
    &__right {
      width: 27px;
      position: absolute;
      right: -1px;
      bottom: -2px;
      border-radius: 0 0 12px 0;
    }
  }
  .topic-option {
    width: 25%;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-left: 10px solid #f2f2f2;
    background: #fff;
    .option-btn {
      width: 200px;
    }
    .point-selected {
      width: 200px;
      display: flex;
      align-items: center;
      background-color: #f2f2f2;
      color: #000000;
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      height: 48px;
      justify-content: center;
    }
    .topic-selected {
      width: 160px;
      background-color: #f2f2f2;
      padding: 0 20px;
      .selected-header {
        display: flex;
        align-items: center;
        color: #000000;
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        height: 48px;
        justify-content: center;
        border-bottom: 1px solid #dce1eb;
      }
      .selected-content {
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #5a5e66;
        .content-item {
          display: flex;
          justify-content: space-between;
          padding: 10px 0;
        }
      }
    }
  }
  .content {
    min-height: 148px;
    border: 3px solid rgba(118, 194, 255, 0.14);
    border-radius: 12px;
    padding-top: 17px;
    margin-left: 28px;
    margin-top: 28px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    .title-uuid {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1989FA;
      text-decoration: underline;
    }
    &__audio {
      margin: 6px 0;
      margin-left: 25px;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: #f7ca08;
      .audio-pause {
        width: 36px;
        height: 36px;
        // border-radius: 50%;
        background: url("~@/views/pt/images/audio_pause.png") no-repeat center center;
        background-size: 22px 15px;
        &.voice-playing {
          background: url("~@/views/pt/images/audio_playing.gif") no-repeat center
            center;
          background-size: 22px 15px;
        }
      }
    }
    &__title {
      padding: 5px;
      margin-left: 25px;
      display: inline-block;
      min-width: 89px;
      height: 24px;
      background: #f0f2f5;
      border-radius: 3px;
      border: 1px solid #d7dfec;
      font-size: 13px;
      color: #5a5e66;
      text-align: center;
      line-height: 24px;
    }
    &__count {
      margin: 16px 0;
      width: 584px;
      font-size: 15px;
      padding: 0 25px;
      color: #111f2c;
      line-height: 21px;
      display: flex;
    }
    &__option {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      border-bottom: 1px dashed #dce1eb;
      padding-bottom: 3px;
      font-size: 14px;
      div {
        display: flex;
        align-items: center;
      }
    }
    &__footer {
      width: 100%;
      height: 52px;
      line-height: 52px;
      display: flex;
      padding-left: 25px;
      box-sizing: border-box;
      justify-content: space-between;
      background: url("../../images/footerbg.png") no-repeat;
      background-size: 100% 100%;
      div {
        display: flex;
        align-items: center;
        p {
          margin-right: 20px;
          font-size: 14px;
        }
      }
      .footer__right {
        color: #1989fa;
        font-size: 14px;
        .basket {
          display: inline-block;
          width: 108px;
          height: 32px;
          background: #1989fa;
          border-radius: 6px;
          line-height: 32px;
          text-align: center;
          color: #ffffff;
          margin-right: 20px;
          &.includes {
            background: #ffffff;
            color: #1989fa;
          }
          .basket-content {
            font-size: 14px;
            box-sizing: border-box;
            padding-left: 15px;
            background: url("../../images/add_witle.png") no-repeat left center;
            background-size: 12px 12px;
            &.includes {
              padding: 0px;
            }
          }
        }
        .tickling {
          background: url("../../images/feedback.png") no-repeat left center;
          background-size: 13px 17px;
          text-indent: 18px;
        }
        .analysis {
          background: url("../../images/examine-analysis.png") no-repeat left
            center;
          background-size: 13px 15px;
          text-indent: 18px;
        }
        .putOut {
          background: url("../../images/delete.png") no-repeat 20px center;
          background-size: 13px 15px;
          // text-indent: 18px;
          font-size: 14px;
          width: 108px;
          text-align: center;
        }
      }
    }
  }
  .question-analysis {
    margin-left: 48px;
    margin-right: 20px;
    min-height: 219px;
    border: 3px solid rgba(118, 194, 255, 0.14);
    border-radius: 12px;
    padding: 15px 20px;
    &__option {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      border-bottom: 1px dashed #dce1eb;
      padding-bottom: 20px;
      font-size: 14px;
      div {
        display: flex;
        align-items: center;
      }
    }
    &__answer {
      font-size: 15px !important;
      color: #000000;
      line-height: 53px;
      border-bottom: 1px dashed #dce1eb;
      display: flex;
      .completion {
        display: flex;
        align-items: center;
      }
      .right-answer {
        display: flex;
        justify-content: flex-start;
        color: #67c23a;
        margin-right: 10px;
        font-size: 15px !important;
      }
    }
    &__text {
      font-size: 15px;
      min-width: 120px;
      color: #000000;
      line-height: 53px;
      display: flex;
      .text-content {
        margin-top: 15px;
        p {
          line-height: 24px;
        }
      }
    }
    &__videos {
      margin-top: 17px;
      border-top: 1px dashed #dce1eb;
      font-size: 15px;
      color: #000000;
      height: 53px;
      display: flex;
      align-items: center;
      .video-content {
        display: inline-block;
        width: 84px;
        height: 28px;
        background: #ffa82d;
        border-radius: 14px;
        margin-left: 45px;
        line-height: 28px;
        span {
          font-size: 16px;
          display: inline-block;
          background: url("../../images/play_video.png") no-repeat left center;
          background-size: 24px 24px;
          box-sizing: border-box;
          padding-left: 32px;
          text-align: center;
          margin-left: 2px;
          color: #ffffff;
        }
      }
    }
  }
  .empty {
    img {
      width: 209px;
      height: 147px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 30px;
    }
  }
  /deep/ .el-pagination {
    display: flex;
    position: absolute;
    padding-top: 20px;
    // width: calc(100% - 64px);
    bottom: -40px;
    left: 30px;
    .btn-prev {
      margin-left: auto;
    }
  }
  .error {
    display: flex;
    margin-top: 10px;
    font-size: 16px;
    &-label {
      width: 110px;
      font-size: 18px;
      font-weight: 500;
    }
    .mr {
      margin-right: 10px;
    }
    &-student {
      margin-top: 15px;
      position: relative;
      min-width: 400px;
      max-width: 700px;
      line-height: 24px;
      padding: 18px 20px;
      border: 1px solid #ebeef5;
      border-radius: 4px;
      background-color: #fff;
      box-shadow: 0 2px 2px 0 ;
      word-break: break-all;
      .top  {
        position: absolute;
        color: #ccc;
        font-size: 20px;
        top: -13px;
      }
    }
    &-answer {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      margin: 15px;
      /deep/ {
        .el-progress {
          flex: 1;
        }
        .el-icon-arrow-up:before {
          content: "\e6e1";
        }
      }
    }
  }
}

.selected-sign {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #000000;
  margin-right: 6px;
}
.selected-num {
}

.empty {
  img {
    width: 209px;
    height: 147px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 30px;
  }
}
</style>
